import { IPaginationDTO, ISubmissionDTO } from '@/dtos';
import { generatePagination, get } from '../apiWrapper';

export const getAllSubmissionsAPI = async (
  branchId: string,
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ISubmissionDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const submissions = await get<{ data: ISubmissionDTO[]; count: number }>(
    `/admin/year/${yearId}/branch/${branchId}/submissions${pageOptions}`,
  );
  return submissions;
};
